export default __webpack_public_path__ + "img/chemical.37605312.jpg";